import { ICPlusPlusReport } from "@/views/reports/ICPlusPlusReport";

/**
 * The "Blended + IC++" report shares the exact same transaction and payout column layouts as the pure
 * IC++ report (including all backward-compatible legacy/intermediate layouts), so it reuses
 * {@link ICPlusPlusReport}'s header logic instead of duplicating it. It is kept as a distinct type so the
 * report factory and callers can still select it by template.
 */
export class BlendedAndICReport extends ICPlusPlusReport {
}
